<app-generic-enum-drop-down
    [field]="field"
    [formControl]="formControl"
    [filteredItems]="itemsSig()"
    [items]="itemsSig()"
    [multiple]="false"
    [offlineMode]="true"
>
</app-generic-enum-drop-down>
